import { Link } from 'react-router-dom';
import { MapPin, Clock, DollarSign, Star, TrendingUp } from 'lucide-react';

export default function LatestTours({ tours }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {tours.map((tour) => (
        <Link key={tour.id} to={`/tour/${tour.id}`} className="group">
          <div className="card overflow-hidden h-full flex flex-col">
            {/* Image Container */}
            <div className="relative overflow-hidden bg-gray-200 dark:bg-slate-800 h-48">
              <img
                src={`https://backend.ysskytravel.com/uploads/tours/${tour.image_url}`} 
                alt={tour.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              
              {/* Discount Badge */}
              {tour.discount_price && (
                <div className="absolute top-4 right-4 bg-[#14bceb] text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                  Sale
                </div>
              )}

              {/* Trending Badge */}
              <div className="absolute top-4 left-4 bg-green-500 text-white px-3 py-1 rounded-full flex items-center gap-1 text-sm font-medium shadow-lg">
                <TrendingUp className="w-3 h-3" />
                Popular
              </div>
            </div>

            {/* Content */}
            <div className="p-5 flex flex-col flex-grow">
              {/* Category */}
              <div className="inline-block mb-3">
                <span className="bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 px-2 py-1 rounded-md text-xs font-semibold">
                  {tour.category_name}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-3 line-clamp-2 group-hover:text-green-500 transition-colors">
                {tour.title}
              </h3>

              {/* Meta Information */}
              <div className="space-y-2 mb-4 flex-grow">
                <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                  <MapPin className="w-4 h-4 text-green-500" />
                  <span>{tour.location}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                  <Clock className="w-4 h-4 text-green-500" />
                  <span>{tour.duration} days</span>
                </div>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-2 mb-4">
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={14}
                      className={
                        i < Math.floor(tour.rating || 4)
                          ? 'fill-green-500 text-green-500'
                          : 'text-gray-300 dark:text-gray-600'
                      }
                    />
                  ))}
                </div>
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  ({tour.reviews_count || 0})
                </span>
              </div>

              {/* Price */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-200 dark:border-slate-800">
                <div className="flex items-baseline gap-2">
                  {tour.discount_price ? (
                    <>
                      <span className="text-2xl font-bold text-green-500">
                        $ {tour.discount_price}
                      </span>
                      <span className="text-sm text-gray-500 line-through">
                        $ {tour.price}
                      </span>
                    </>
                  ) : (
                    <span className="text-2xl font-bold text-gray-900 dark:text-white">
                      $ {tour.price}
                    </span>
                  )}
                </div>
                <DollarSign className="w-5 h-5 text-green-500/30" />
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
